var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "document", "data-size": "1x1" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _c(
          "div",
          { staticClass: "go-card-body" },
          [
            _c("div", { staticClass: "go-block-header" }, [
              _c("div", { staticClass: "go-card-info" }, [
                _c("div", { staticClass: "go-info-item go-channel" }, [
                  _c("span", { staticClass: "go-channel-thumb" }, [
                    _c("img", {
                      attrs: {
                        width: "16px",
                        height: "16px",
                        src: _vm.favicon,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "go-channel-name" }, [
                    _vm._v(_vm._s(_vm.formModel.channel)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-body" }, [
              _c(
                "a",
                { staticClass: "go-card-title", on: { click: _vm.viewDetail } },
                [_vm._v(_vm._s(_vm.formModel.title))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-block-wrap" }, [
                _c("div", { staticClass: "go-card-desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formModel.content) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-card-icon" }, [
                  _vm.fileType === "PDF"
                    ? _c("img", {
                        attrs: {
                          src: "/content/images/images_v4/common/go-icon-document/file-pdf-fill.svg",
                          alt: "PDF File",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileType === "DOC"
                    ? _c("img", {
                        attrs: {
                          src: "/content/images/images_v4/common/go-icon-document/file-word-fill.svg",
                          alt: "Word File",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileType === "EXCEL"
                    ? _c("img", {
                        attrs: {
                          src: "/content/images/images_v4/common/go-icon-document/file-excel-fill.svg",
                          alt: "Excel File",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileType === "TEXT"
                    ? _c("img", {
                        attrs: {
                          src: "/content/images/images_v4/common/go-icon-document/file-text-fill.svg",
                          alt: "Text File",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileType === "PPT"
                    ? _c("img", {
                        attrs: {
                          src: "/content/images/images_v4/common/go-icon-document/file-ppt-fill.svg",
                          alt: "PPT File",
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("resource-footer", {
              attrs: {
                "form-model": _vm.formModel,
                "is-hide-options": _vm.isHideOptions,
                "is-hide-add-reference": _vm.isHideAddReference,
                "is-hide-goover": _vm.isHideGoover,
                "is-hide-hidden": _vm.isHideHidden,
                "is-hide-shared": _vm.isHideShared,
              },
              on: {
                "add-to-reference": _vm.addToReference,
                hide: function ($event) {
                  $event.stopPropagation()
                  return _vm.hide.apply(null, arguments)
                },
                share: _vm.share,
                "select-user-social": _vm.selectUserSocial,
                "toggle-resource": _vm.toggleResource,
                goover: _vm.goover,
              },
            }),
            _vm._v(" "),
            _vm.formModel.isNew
              ? _c("div", { staticClass: "go-card-new" })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }